import { useEffect, useRef } from 'react';
import type { ReactNode } from 'react';

/** CSS motion only runs while its illustration is in view. */
export default function MotionScene({ children, className = '', paused = false, label }: { children: ReactNode; className?: string; paused?: boolean; label?: string }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const element = ref.current;
    if (!element) return;
    const observer = new IntersectionObserver(([entry]) => {
      element.dataset.visible = String(entry.isIntersecting);
    }, { threshold: 0.15 });
    observer.observe(element);
    return () => observer.disconnect();
  }, []);
  return <div ref={ref} role={label ? 'region' : undefined} aria-label={label} tabIndex={label ? 0 : undefined} className={`motion-scene ${className}`} data-paused={paused} data-visible="false">{children}</div>;
}
